/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { withCompatRouter } from 'sarsaparilla/legacy';

import { fetchPermit, fetchRecarea, fetchDailyLotteries } from '../actions/permit';
import LotterySchedule from '../components/lottery-schedule/LotterySchedule';
import {
    type Permit,
    type DailyLottery,
    formatLotteries,
} from '../utils/lottery-schedule-utils';

type PropTypes = {
    permit: Permit;
    permitError: string;
    recarea: any;
    recareaError: string;
    dailyLotteries: DailyLottery[];
    dailyLotteriesError: string;

    // actions
    fetchDailyLotteries: (permitId?: string) => void;
    fetchPermit: (permitId?: string) => void;
    fetchRecarea: (recId?: string) => void;

    // react-router
    router: {
        params: {
            permitId: string;
        };
        location: {
            pathname: string;
        };
    };
};

export class LotterySchedulePage extends Component<PropTypes> {
    componentDidMount() {
        const permitId = this.getPermitIdFromUrlPath();
        this.props.fetchPermit(permitId);
        this.props.fetchDailyLotteries(permitId);
        this.updateRecarea();
    }

    componentDidUpdate(prevProps: PropTypes) {
        const { permit } = this.props;

        // get recarea when permit changes
        const permitId = get(permit, 'id');
        if (permitId && permitId !== get(prevProps, 'permit.id')) {
            this.updateRecarea();
        }
    }

    getPermitIdFromUrlPath() {
        return this.props.router.params.permitId;
    }

    updateRecarea() {
        const { permit } = this.props;
        if (get(permit, 'id')) {
            const recId = get(permit, 'recareas[0]');
            if (recId) this.props.fetchRecarea(recId);
        }
    }

    render() {
        const {
            permit,
            permitError,
            recarea,
            recareaError,
            dailyLotteries,
            dailyLotteriesError,
        } = this.props;

        return (
            <LotterySchedule
                permitID={this.getPermitIdFromUrlPath()}
                permit={permit}
                permitError={permitError}
                recarea={recarea}
                recareaError={recareaError}
                dailyLotteries={dailyLotteries}
                dailyLotteriesError={dailyLotteriesError}
            />
        );
    }
}

function mapStateToProps(state: any) {
    return {
        permit: state.permit.result,
        permitError: state.permit.error,
        recarea: state.permit.recarea,
        recareaError: state.permit.recareaError,
        dailyLotteries: formatLotteries(
            state.permit.daily_lotteries,
            state.permit.result
        ),
        dailyLotteriesError: state.permit.daily_lotteries_err,
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        fetchPermit: (permitId?: string) => dispatch(fetchPermit(permitId)),
        fetchRecarea: (recId?: string) => dispatch(fetchRecarea(recId)),
        fetchDailyLotteries: (permitId?: string) =>
            dispatch(fetchDailyLotteries(permitId)),
    };
}

export default withCompatRouter(
    connect(mapStateToProps, mapDispatchToProps)(LotterySchedulePage)
);
